import React from 'react';
import { Link } from "gatsby";
import Layout from "../../layouts/tc";
import eventCover from '../../images/event-kol.jpg';

export default function Home(props) {
  return (
    <Layout location={props.location} title="「關鍵意見領袖」短片製作工作坊">
      <div className="lg:py-20 py-10">
        <div className="container mx-auto px-4 lg:px-0">
          <nav class="mb-4">
            <Link to="/tc">首頁</Link>
            <span class="mx-3 text-gray-700">/</span>
            <span class="text-gray-500">「關鍵意見領袖」短片製作工作坊</span>
          </nav>

          <div className="mt-5">
            <div className="lg:flex">
              <div className="lg:w-96">
                <img src={eventCover} className="rounded" alt="" />
              </div>
              <div className="lg:flex-1 lg:ml-10">
                <h1 className="lg:text-2xl font-bold lg:mt-0 mt-5">「關鍵意見領袖」短片製作工作坊</h1>
                
                <div className="mt-5 leading-loose">
                  <ul className="list-disc ml-5">
                    <li>同學將學習如何製作短片，學習將構思寫成情節，使用軟件製作2分鐘短片，並明白建立個人品牌的重點</li>
                    <li>同學完成兩節工作坊後，5-6位同學將於5月5日中午12時正前合力製作一條長約2分鐘的短片，主題為「我的教大生活」或「我們的夢」。導師將會為每組同學提供1.5小時的諮詢，為同學作品提供意見</li>
                    <li>所有小組作品將於5月5日至5月11日中午12時期間上載於社交平台 “Instagram” 企業及創新教育組專頁供公眾投票，獲得最多 “Like”的作品將獲選為「最佳短片大獎」，得獎者將獲得$1,500書券及證書</li>
                    <li>比賽結果將於5月11日於 EIEU 網站公佈比賽</li>
                  </ul>
                  <div className="mt-5 border-t pt-5">
                    <div className="lg:flex lg:items-center">
                      <label className="lg:w-48 text-gray-500">日期/時間:</label>
                      <div className="lg:flex-1">
                      4月7日及4月14日下午2時至5時
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">講者:</label>
                      <div className="lg:flex-1">
                      籽識教育
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">地點:</label>
                      <div className="lg:flex-1">
                      以Zoom線上形式進行
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">名額:</label>
                      <div className="lg:flex-1">
                        30
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">報名截止日期:</label>
                      <div className="lg:flex-1">
                      4月5日
                      </div>
                    </div>
                    <p className="mt-5">
                    活動名額有限，先到先得。活動Zoom 連結將於活動舉行一日前，以電郵通知成功報名活動的同學。
                    </p>
                    <a href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo" className="cta mt-5 inline-block" target="_blank" rel="noreferrer">報名</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
};